import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminLogin from '../components/admin/AdminLogin';
import AdminLayout from '../components/admin/AdminLayout';
import AdminDashboard from '../components/admin/AdminDashboard';
import ExperiencesAdmin from '../components/admin/ExperiencesAdmin';
import SkillsAdmin from '../components/admin/SkillsAdmin';
import EducationAdmin from '../components/admin/EducationAdmin';
import CertificationsAdmin from '../components/admin/CertificationsAdmin';
import LanguagesAdmin from '../components/admin/LanguagesAdmin';
import SettingsAdmin from '../components/admin/SettingsAdmin';
import MessagesAdmin from '../components/admin/MessagesAdmin';
import PreviewAdmin from '../components/admin/PreviewAdmin';

const AdminPage = () => {
  const { user, loading } = useAuth();

  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center"><div className="animate-pulse text-lime-400 text-xl">Carregando...</div></div>;
  if (!user) return <AdminLogin />;

  return (
    <AdminLayout>
      <Routes>
        <Route index element={<AdminDashboard />} />
        <Route path="experiences" element={<ExperiencesAdmin />} />
        <Route path="skills" element={<SkillsAdmin />} />
        <Route path="education" element={<EducationAdmin />} />
        <Route path="certifications" element={<CertificationsAdmin />} />
        <Route path="languages" element={<LanguagesAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
        <Route path="messages" element={<MessagesAdmin />} />
        <Route path="preview" element={<PreviewAdmin />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminPage;
